module.exports = __webpack_public_path__ + "static/media/fly0132.9f32ab09.webp";